module.exports = function ($container) {

	var KEYS_VALUES = {
		tab: 9,
		rightArrow: 39
	};
	var MIN_QUERY_LENGTH = 2;

	window.typeAheadCache = {};

	var clearTypeAhead = function() {};

	var $searchInputs = $container.find('.search-type-ahead-input');

	$.each($searchInputs, function (inputIndex, inputItem) {
		var $searchInput = $(inputItem);
		var inputContentVal = $searchInput.attr('id');

		var $typeAheadContainer = $('.search-bar__type-ahead[data-type-ahead-input="' + inputContentVal + '"]');

		var $typeAheadHidden = $typeAheadContainer.find('.search-type-ahead-hidden');
		var $typeAheadVisible = $typeAheadContainer.find('.search-type-ahead-visible');

		var initialValue = $searchInput.data('initialValue');
		if (initialValue) {
			$searchInput.val(initialValue);
		}

		clearTypeAhead = function () {
			$typeAheadHidden.text('');
			$typeAheadVisible.text('');
		};

		// when typing
		$searchInput.keyup(function (e) {
			var currentVal = $searchInput.val();

			if (currentVal.indexOf(' ') === -1 && currentVal.length >= MIN_QUERY_LENGTH) {
				var updateTypeAhead = function (word, val) {

					if ($searchInput.val() !== val) {
						return;
					}

					console.log($typeAheadHidden);
					console.log($typeAheadVisible);
					$typeAheadHidden.text(val);
					$typeAheadVisible.text(word.substring(val.length));
				};

				if (currentVal in window.typeAheadCache) {
					updateTypeAhead(window.typeAheadCache[currentVal], currentVal);
					return;
				}

				clearTypeAhead();

				Innophos.Modules.SiteSearchBar.TypeAheadSearch(currentVal, function (results) {
					if (results && results.results && results.results.length) {
						var matchedWord = results.results[0];

						window.typeAheadCache[currentVal] = matchedWord;

						updateTypeAhead(matchedWord, currentVal);
					}
					else {
						clearTypeAhead();
					}
				});
			}
			else {
				clearTypeAhead();
			}
		});

		// handle pressing tab / right arrow
		$searchInput.keydown(function (e) {
			var keyCode = e.which || e.keyCode;

			if (keyCode === KEYS_VALUES['tab'] || keyCode === KEYS_VALUES['rightArrow']) {
				var currentVal = $searchInput.val().toLowerCase();

				if (currentVal.length >= MIN_QUERY_LENGTH && currentVal in window.typeAheadCache) {
					e.preventDefault();
					clearTypeAhead();
					$searchInput.val(window.typeAheadCache[currentVal]);
					$searchInput.focus();
				}
			}
		});
	});

	return {
		clearTypeAhead: clearTypeAhead
	};
};
